module.exports = __webpack_public_path__ + "img/mood_love.5785f39c.png";